var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionFemme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196,
    height: 275,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M181.14 71.89s1.05-4.102 2.777-5.155c1.726-1.091 4.165-2.22 4.728-2.71.563-.489 1.201.941-.413 2.032l-1.614 1.092c0 .3 0 .526.075.677.263.752 1.126 1.28 2.215 1.392 4.127.865 5.779.903 6.379.715.113 0 .45-.15.6 0 .226.263-.187 1.091-.375 1.355-1.126 1.73-5.028 2.445-7.918 1.128-1.051-.489-1.463-1.016-2.251-.903-1.239.226-1.989 1.844-2.44 3.199l-1.763-2.86v.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M184.479 71.776c4.691 2.483 2.59 23.592-9.907 34.918-2.251 2.032-8.48 7.45-16.286 6.396-7.017-.94-11.333-6.584-13.397-9.293-12.834-16.782-4.278-43.384-2.777-47.75 1.952.866 4.841 2.409 7.58 5.156 5.292 5.305 7.243 12.304 8.632 17.61 2.064 7.788 1.351 11.024 3.527 11.852 3.49 1.354 9.307-5.456 11.483-8.015 3.152-3.687 5.029-7.262 6.117-9.595 2.664-1.73 4.165-1.768 5.066-1.28h-.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M116.632 266.76s-.375 2.972-.113 3.951c.263.978 8.819 1.693 11.746 1.354 2.927-.338-1.726-3.311-3.603-3.875-1.838-.565-8.03-1.43-8.03-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m120.947 261.831-.9 5.945s-2.289 1.053-3.415 0l-.113-6.209 4.428.264Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M72.614 261.567s1.8 1.355 1.35 2.973c-.487 1.618-4.728 8.127-7.767 9.971-3.04 1.844-2.065-1.994-1.201-4.402.863-2.409 3.114-7.676 4.015-8.542.863-.865 3.603 0 3.603 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M75.916 255.058a77.768 77.768 0 0 1-2.402 5.982c-1.463 3.311-2.251 4.516-3.152 5.607-.788.94-2.664 2.935-3.152 2.596-.526-.339.863-2.747 3.49-9.858.375-1.016 1.576-4.327 1.576-4.327h3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M138.885 152.411a152.696 152.696 0 0 1 .338 27.392c-1.164 15.164-4.203 24.759-7.993 40.901-2.327 9.858-5.442 24.42-8.256 42.594-.638.376-2.59 1.354-5.066.978-1.389-.226-2.439-.753-3.04-1.167-7.43-22.726-5.216-36.761-1.651-45.528 1.539-3.725 3.377-6.698 4.353-12.417 1.313-7.601-.3-11.853-2.627-29.462-1.651-12.53-1.351-14.487-.263-16.368 4.354-7.525 17.75-7.375 24.205-6.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M113.367 155.045c-4.541 23.517-9.006 35.858-12.384 42.857-.825 1.731-3.602 7.262-6.229 15.239-2.327 7.036-3.302 12.229-3.79 14.524-1.576 7.224-5.442 17.722-15.836 31.532-.113.075-1.914 1.091-3.603.188-.863-.452-1.276-1.167-1.463-1.505a605.63 605.63 0 0 1 4.278-32.849c.3-1.806 1.538-9.632 3.49-20.017a583.264 583.264 0 0 1 3.227-16.105c1.689-7.6 4.24-17.948 8.218-30.365 7.993-1.166 16.024-2.295 24.017-3.461l.075-.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M114.042 64.214c3.49-3.236 10.133-6.924 13.472-15.578 1.014-2.596 4.579-11.815-.675-18.851-3.115-4.177-8.894-7.036-13.997-6.02-4.353.865-5.029 3.913-12.422 10.008-2.89 2.37-7.505 6.209-12.683 8.353-8.82 3.65-14.148.226-23.004.602-10.883.49-23.53 6.585-29.646 15.428-10.808 15.728 4.841 31.682-6.98 50.119-3.865 6.02-5.779 4.666-15.01 16.368C3.865 136.382-.713 142.214.075 149.401c1.126 9.934 11.82 19.453 21.878 20.093 9.832.64 16.099-7.112 21.09-3.725 3.565 2.408 1.538 7.111 5.29 12.755 4.88 7.262 14.449 8.73 16.025 8.956 14.372 2.182 33.736-14.712 41.992-34.73 14.822-36.084-11.22-71.002 7.655-88.536h.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F46",
    d: "M113.217 217.581c1.539-3.725 3.377-6.697 4.353-12.417 1.313-7.6-.3-11.852-2.627-29.461-1.651-12.53-1.351-14.487-.263-16.368 2.365-4.102 7.393-5.908 12.534-6.66-.075.263-.15.527-.187.79-2.702 12.342 7.58 19.867 2.964 33.45-2.289 6.698-5.929 8.203-6.792 15.992-.788 7.262 2.101 8.767 1.463 15.389-.938 9.859-7.918 12.267-9.719 19.83-1.201 4.929-.187 12.078 8.444 22.501a64.93 64.93 0 0 0-.413 2.709c-.638.376-2.59 1.354-5.066.978-1.389-.226-2.439-.752-3.04-1.166-7.43-22.727-5.216-36.762-1.651-45.529v-.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M148.379 60.262c-.675-1.053-2.852-3.988-12.008-6.17-4.579-1.092-13.097-2.936-24.017-.603-15.01 3.199-24.355 12.23-27.882 16.03 2.89 1.88 10.845 7.638 14.785 18.512 1.239 3.386 4.841 14.975-.338 25.812-3.002 6.246-8.255 10.95-12.27 14.524-6.005 5.343-9.12 6.171-11.146 10.95-2.177 5.23 0 7.751-2.702 11.325-2.927 3.838-6.342 2.07-11.333 5.945-5.066 3.989-3.265 7.262-7.918 11.627-6.717 6.397-15.648 4.29-16.061 7.187-.375 2.483 5.967 5.832 11.37 7.187 10.658 2.709 19.964-1.844 22.704-3.236 7.655-3.838 6.342-6.359 12.158-9.294 9.757-4.929 16.437.564 38.69 1.129 12.046.301 18.125.376 21.465-3.725 3.04-3.726 1.463-7.827-.375-25.474-.601-5.907-1.802-18.249-1.839-25.285 0-4.139 1.426-10.95 4.315-24.533.188-.79 1.727-8.128 2.965-17.948 1.126-8.843.976-11.552-.638-13.997l.075.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M53.55 168.252c4.616-4.403 2.815-7.676 7.918-11.627 4.954-3.876 8.406-2.107 11.333-5.945 2.74-3.575.525-6.133 2.702-11.326 2.026-4.779 5.141-5.606 11.145-10.949 4.016-3.575 9.27-8.278 12.271-14.524 5.179-10.837 1.577-22.426.338-25.813-3.94-10.874-11.896-16.63-14.785-18.512.263-.301.6-.64.938-1.016 18.988 2.634 30.059 13.621 31.447 16.895 3.152 7.525-1.839 10.31-1.989 32.02-.075 10.385 1.051 14.487-2.289 18.814-3.828 4.966-8.256 3.424-13.81 9.896-4.278 4.966-3.602 8.127-7.58 10.234-4.278 2.258-7.017-.376-11.858.677-8.069 1.731-9.795 11.063-15.123 16.18-4.053 3.876-11.521 6.547-26.231 3.65-.338-.489-.488-.978-.45-1.43.412-2.86 9.343-.79 16.06-7.187l-.037-.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M118.508 41.712s-.976 7.676-3.79 9.444c-2.815 1.769-7.393 4.064-7.881 4.666-.487.64 17.488 2.559 26.419-1.957-2.927-.602-3.753-.827-3.753-.827-.788-.226-2.289-.64-3.79-1.505-1.013-.565-2.664-1.731-4.165-3.838v-4.252l-3.077-1.731h.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M112.466 45.099s4.053 5.606 10.433 3.273c5.704-2.07 2.289-16.857-2.214-18.55-1.501-.564-4.278-.3-6.117.828-1.314.828-4.766 5.155-2.777 10.009-1.426-.414-2.702-.038-3.04.677-.413.903.826 2.145 1.089 2.408a4.644 4.644 0 0 0 2.664 1.317l-.038.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M62.782 72.416s.187-4.214-1.164-5.757c-1.35-1.542-3.377-3.349-3.752-3.95-.413-.603-1.426.564-.188 2.069l1.238 1.505c-.037.301-.15.49-.262.64-.45.677-1.464.903-2.515.715-4.203-.339-5.779-.79-6.342-1.13-.075-.037-.375-.263-.6-.15-.3.188-.113 1.091 0 1.43.6 1.957 4.09 3.8 7.28 3.349 1.164-.15 1.689-.564 2.402-.188 1.126.564 1.388 2.333 1.426 3.763l2.514-2.22-.037-.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M59.292 72.416c-4.466 2.37-2.702 16.856 2.89 27.543 2.1 4.026 9.118 17.421 18.912 17.082 9.982-.338 16.137-14.561 18.764-20.582 6.717-15.464 4.953-30.628 2.852-39.772-14.11 4.629-18.2 10.085-19.214 14.336-.563 2.296-.563 5.833-2.176 14.562-1.014 5.418-1.426 6.472-2.214 6.735-1.69.565-5.33-2.52-13.735-18.587-1.726-1.054-4.24-2.258-6.08-1.28v-.037Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M188.484 22.504c.42 12.038-8.959 22.587-21.36 23.596-12.879 1.047-24.054-8.524-24.504-21.416-.449-12.892 10.022-23.492 22.931-23.67 12.43-.171 22.513 9.453 22.933 21.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M189.505 22.468c.42 12.038-8.959 22.587-21.36 23.596-12.878 1.047-24.054-8.524-24.504-21.416-.449-12.892 10.022-23.492 22.931-23.67 12.43-.172 22.513 9.453 22.933 21.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M188.225 22.53c.396 11.341-8.452 21.264-20.127 22.19-12.097.96-22.573-8.044-22.995-20.141-.422-12.098 9.392-22.065 21.516-22.257 11.701-.185 21.21 8.865 21.606 20.207Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158.287 11.434c.499-.455 1.047-.89 1.644-1.302a12.066 12.066 0 0 1 1.935-1.084 12.24 12.24 0 0 1 2.259-.747 13.09 13.09 0 0 1 2.636-.316c1.282-.031 2.451.114 3.509.435 1.054.32 1.962.79 2.724 1.41a6.631 6.631 0 0 1 1.793 2.266c.435.89.672 1.894.711 3.011.039 1.118-.088 2.037-.377 2.845a7.853 7.853 0 0 1-1.128 2.127 9.666 9.666 0 0 1-1.522 1.6c-.551.459-1.076.89-1.572 1.297-.498.406-.927.803-1.288 1.19-.36.387-.57.814-.627 1.281l-.396 3.198-3.745.207-.504-3.543a.91.91 0 0 1-.028-.184l-.007-.186c-.022-.642.122-1.207.432-1.696a6.96 6.96 0 0 1 1.178-1.388c.473-.436.983-.862 1.531-1.278a14.176 14.176 0 0 0 1.521-1.338 6.45 6.45 0 0 0 1.154-1.599c.301-.59.438-1.274.411-2.054a3.2 3.2 0 0 0-.344-1.386 3.192 3.192 0 0 0-.86-1.035 3.748 3.748 0 0 0-1.29-.644 5.212 5.212 0 0 0-1.612-.19c-.843.026-1.555.139-2.136.339-.582.2-1.074.42-1.476.66-.403.24-.744.456-1.022.648-.279.192-.53.292-.756.3-.541.018-.94-.19-1.196-.622l-1.552-2.223v.001Zm5.166 25.705c-.016-.453.055-.89.212-1.31.157-.42.383-.785.679-1.097a3.658 3.658 0 0 1 1.056-.768 3.47 3.47 0 0 1 1.324-.345c.458-.029.896.031 1.315.18.417.147.778.357 1.082.628.303.27.55.603.74.996a3.278 3.278 0 0 1 .09 2.57 3.354 3.354 0 0 1-1.702 1.841 3.541 3.541 0 0 1-1.296.346 3.479 3.479 0 0 1-1.341-.155 3.196 3.196 0 0 1-1.105-.611c-.316-.27-.566-.6-.751-.99a3.205 3.205 0 0 1-.303-1.285Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M157.021 14.107c-.849-2.464-.946-6.25 2.578-11.972-9.499 3.11-16.321 12.082-15.957 22.512.449 12.893 11.625 22.464 24.504 21.417a23.374 23.374 0 0 0 12.516-4.875c-.23-3.434-1.108-7.172-3.329-10.569-6.105-9.34-17.645-8.782-20.312-16.513Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 141.504,
    x2: 173.745,
    y1: 102.339,
    y2: 62.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6064D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1BEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 37.489,
    x2: 117.87,
    y1: 123.287,
    y2: 123.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6064D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8BC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 124.062,
    x2: 121.082,
    y1: 247.758,
    y2: 301.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 118.471,
    x2: 120.055,
    y1: 274.097,
    y2: 201.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 70.437,
    x2: 67.457,
    y1: 244.786,
    y2: 298.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 71.263,
    x2: 72.809,
    y1: 273.081,
    y2: 200.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 141.324,
    x2: 111.313,
    y1: 227.176,
    y2: 187.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201D3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 119.109,
    x2: 48.91,
    y1: 232.18,
    y2: 166.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201D3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 50.51,
    x2: 78.605,
    y1: 135.592,
    y2: 95.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 37.489,
    x2: 149.73,
    y1: 117.907,
    y2: 117.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6064D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1BEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 189.634,
    x2: 165.994,
    y1: 68.136,
    y2: 131.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 121.022,
    x2: 102.643,
    y1: 56.311,
    y2: 29.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 122.561,
    x2: 58.713,
    y1: 41.487,
    y2: 3.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 55.695,
    x2: 60.195,
    y1: 66.225,
    y2: 133.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 101.773,
    x2: 69.651,
    y1: 103.151,
    y2: 63.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6064D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1BEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 150.475,
    x2: 182.856,
    y1: 55.08,
    y2: -12.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 151.496,
    x2: 183.877,
    y1: 55.044,
    y2: -12.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 178.355,
    x2: 120.323,
    y1: 9.619,
    y2: 78.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 143.648,
    x2: 180.047,
    y1: 24.828,
    y2: 23.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 23.576h196V275H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionFemme);
export default __webpack_public_path__ + "static/media/questionFemme.c20b9b5bc551b0087b486e85ef212bc7.svg";
export { ForwardRef as ReactComponent };